import React from 'react';
import * as Fi from 'react-icons/fi';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import { Form, DatePicker, Select } from 'ui/components';
import _ from 'underscore';

import { formatDate } from 'utilities/common';
import CustomerForm from 'ui/screens/authorized/master/customer/component/form';

const initialState = {
  loading: true,
  start_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  end_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  price: 0,
  selectedRepeatType: null,
  selectedRepeatDay: null,
  auto_manifest: false,
  service: null,
  serviceType: null,
  customer: null,
  shipper: null,
  showFormCustomer: false,
};

const repeatTypesOptions = [
  { value: 'every_day', label: 'Setiap Hari' },
  { value: 'custom', label: 'Custom' },
];

const dailyOptions = [
  { value: 'Monday', label: 'Senin' },
  { value: 'Tuesday', label: 'Selasa' },
  { value: 'Wednesday', label: 'Rabu' },
  { value: 'Thursday', label: 'Kamis' },
  { value: 'Friday', label: 'Jumat' },
  { value: 'Saturday', label: 'Sabtu' },
  { value: 'Sunday', label: 'Minggu' },
];

export const General = ({ onChange, data }) => {
  const Session = useSelector((state) => state.Auth?.session);
  const StateForm = useSelector((state) => state?.Form);
  const StateClient = useSelector((state) => state?.Auth?.session?.client);
  const [privilege, setPrivilege] = React.useState(null);

  const [
    {
      selectedRepeatType,
      selectedRepeatDay,
      start_at,
      end_at,
      price,
      auto_manifest,
      service,
      serviceType,
      customer,
      shipper,
      showFormCustomer,
    },
    setState,
  ] = React.useState(initialState);

  const handleChangeDate = async (v, t) => {
    if (t === 'start') {
      if (v !== null) {
        setState((prevState) => ({
          ...prevState,
          start_at: {
            default: v,
            formatted: formatDate(v, 'YYYY-MM-DD'),
          },
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          start_at: null,
        }));
      }
    }

    if (t === 'end') {
      if (v !== null) {
        setState((prevState) => ({
          ...prevState,
          end_at: {
            default: v,
            formatted: formatDate(v, 'YYYY-MM-DD'),
          },
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          end_at: null,
        }));
      }
    }
  };

  const $getPrivilege = async () => {
    const payload = {};

    const customer = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.partner',
    });

    if (customer) {
      payload.customer = customer;
    }

    setPrivilege(payload);
  };

  const $handleSelectedRepeatType = async (e) => {
    setState((prevState) => ({
      ...prevState,
      selectedRepeatType: e,
      selectedRepeatDay: null,
    }));

  }

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    var rd = []
    _.each(selectedRepeatDay, function(x){
      rd.push(x.value)
    })

    const state = {
      repeat_type: selectedRepeatType?.value || '',
      repeat_day: rd,
      start_at,
      end_at,
      price,
      auto_manifest,
      serviceType,
      customer,
      shipper,
      service,
    };

    onChange(state);
  }, [
    selectedRepeatType,
    selectedRepeatDay,
    start_at,
    end_at,
    price,
    auto_manifest,
    serviceType,
    customer,
    shipper,
    service,
  ]);

  React.useEffect(() => {
    if (!data) return;

    const rt = data?.repeat_type === 'every_day' ?
    repeatTypesOptions[0] : data?.repeat_type === 'custom' ? repeatTypesOptions[1] : null

    var rd = []
    _.each(dailyOptions, function(od) {
      _.each(data?.repeat_day, function(v) {
        if (od.value === v) {
          rd.push(od)
        }
      })
    })

    setState((prevState) => ({
      ...prevState,
      selectedRepeatType: rt,
      selectedRepeatDay: rd,
      start_at: {
        default: new Date(data?.periode_start_at),
        formatted: formatDate(data?.periode_start_at, 'YYYY-MM-DD'),
      },
      end_at: {
        default: new Date(data?.periode_end_at),
        formatted: formatDate(data?.periode_end_at, 'YYYY-MM-DD'),
      },
      repeat_type: data?.repeat_type,
      repeat_day: data?.repeat_day,
      price: data?.price,
      auto_manifest: data?.auto_manifest,
      service: data?.service_type?.service,
      serviceType: data?.service_type,
      customer: data?.customer,
      shipper: data?.shipper,
    }));
  }, [data]);

  React.useEffect(() => {
    if (data) return;

    setState((prevState) => ({
      ...prevState,
      shipper: {
        name: StateClient?.name,
        phone: StateClient?.phone,
        address: StateClient?.address,
      },
      selectedRepeatType: repeatTypesOptions[0]
    }));
  }, [StateClient]);

  React.useEffect(() => {
    if (data === undefined) {
      setState((prevState) => ({
        ...prevState,
        service: {
          id: '61cc19d9f42b986ab50c659b',
          name: 'Trucking',
          auto_manifest: true
        },
      }));
    }
  }, [data]);

  return (
    <div className="sidebar h-100">
      <div className="form-group sidebar-body-create py-3 p-3">
        <div className="mb-3">
          <Select.Remote
            label="Pilih Tipe Layanan"
            placeholder=""
            url="/tms/service/type"
            value={serviceType}
            initialValue={serviceType?.id}
            params={{
              service_id: service?.id,
            }}
            row={(d) => {
              return {
                value: d.id,
                label: d.name,
              };
            }}
            onSelected={(c) => {
              setState((prevState) => ({
                ...prevState,
                serviceType: c,
              }));
            }}
            disabled={!service}
            keys={service?.id}
            hint={
              serviceType?.pricing_schema === 'weight_based'
                ? `min. weight : ${serviceType?.min_weight} Kg`
                : null
            }
          />
        </div>
        <div className="mb-3">
          <label className="form-label fs-8">Customer</label>
          <div className="row">
            <div className={'col-10 pe-0'}>
              <Select.Remote
                label=""
                placeholder=""
                url="/partner"
                value={customer}
                initialValue={customer?.id}
                keys={customer?.id}
                params={{"type": "customer"}}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d?.company_name
                      ? `${d.name} - ${d.company_name}`
                      : `${d.name}`,
                  };
                }}
                onSelected={(c) => {
                  setState((prevState) => ({
                    ...prevState,
                    customer: c,
                    shipper: {
                      name: c?.company_name ? c?.company_name : c?.name,
                      phone: c?.pic_phone,
                      address: c?.address,
                    },
                  }));
                }}
                errors={StateForm?.errors?.['shipment.customer_id']}
              />
            </div>
            <div className="col-2 text-end ps-0">
              <button
                type="button"
                className="btn btn-primary rounded px-2"
                style={{ minHeight: 30, minWidth: '80%' }}
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    showFormCustomer: true,
                  }))
                }
                disabled={
                  customer ||
                  (Session?.privileges &&
                    privilege?.customer?.action !== 'manage')
                }
              >
                <Fi.FiPlus color="white" />
              </button>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <Form.Input
              label="Pengirim"
              type="text"
              value={shipper?.name}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  shipper: {
                    ...shipper,
                    name: e?.target?.value,
                  },
                }))
              }
              required
              error={
                StateForm?.errors?.['shipper'] ||
                StateForm?.errors?.['shipper.name']
              }
            />
          </div>
          <div className="col-6">
            <Form.Input
              label="No. Handphone"
              type="text"
              value={shipper?.phone}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  shipper: {
                    ...shipper,
                    phone: e?.target?.value,
                  },
                }))
              }
              required
              error={
                StateForm?.errors?.['shipper'] ||
                StateForm?.errors?.['shipper.phone']
              }
            />
          </div>

          <div className="col-12">
            <Form.Textbox
              label="Alamat"
              type="text"
              value={shipper?.address}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  shipper: {
                    ...shipper,
                    address: e?.target?.value,
                  },
                }))
              }
              error={StateForm?.errors?.['shipper.address']}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <label className="form-label fs-8 required">Periode Awal</label>
            <div
              className={
                StateForm?.errors?.start_at
                  ? 'border border-danger rounded'
                  : ''
              }
            >
              <DatePicker
                type="normal"
                value={start_at?.default || null}
                format="dd/MM/yyyy"
                onChange={(date) => {
                  handleChangeDate(date, 'start');
                }}
                isShowTrigger
              />
            </div>
            {StateForm?.errors?.start_at && (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.start_at}
              </div>
            )}
          </div>

          <div className="col-6">
            <label className="form-label fs-8 required">Periode Akhir</label>
            <div
              className={
                StateForm?.errors?.end_at ? 'border border-danger rounded' : ''
              }
            >
              <DatePicker
                type="normal"
                value={end_at?.default || null}
                format="dd/MM/yyyy"
                onChange={(date) => {
                  handleChangeDate(date, 'end');
                }}
                isShowTrigger
              />
            </div>
            {StateForm?.errors?.end_at && (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.end_at}
              </div>
            )}
          </div>
        </div>

        <div className="mb-3">
          <label className='form-label required'>Pilih Ulangi</label>
          <Select
            required
            isClearable
            classNamePrefix={
              StateForm?.errors?.repeat_type ? 'is-invalid' : 'select'
            }
            placeholder=""
            value={selectedRepeatType}
            options={repeatTypesOptions}
            onChange={$handleSelectedRepeatType}
            error={StateForm?.errors?.repeat_type}
          />

          {StateForm?.errors?.repeat_type ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {StateForm?.errors?.repeat_type}
            </div>
          ) : null}
        </div>

        {(selectedRepeatType && selectedRepeatType?.value === 'custom') && (
          <div className="mb-3">
            <label className='form-label required'>Pilih Hari Ulangi</label>
            <Select
              required
              isClearable
              isMulti
              classNamePrefix={
                StateForm?.errors?.repeat_day ? 'is-invalid' : 'select'
              }
              placeholder=""
              value={selectedRepeatDay}
              options={dailyOptions}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  selectedRepeatDay: e,
                }))
              }
              error={StateForm?.errors?.repeat_day}
            />

            {StateForm?.errors?.repeat_day ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.repeat_day}
              </div>
            ) : null}
          </div>
        )}
        <Form.Input
          value={price}
          onChange={(e) => {
            setState((prevState) => ({
              ...prevState,
              price: e.target.valueNumber,
            }));
          }}
          type="number"
          label="Harga Pengiriman"
          error={StateForm?.errors?.price}
        />

        <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
          <div
            className="text-center position-relative"
            onClick={() => {
              setState((prevState) => ({
                ...prevState,
                auto_manifest: auto_manifest ? false : true,
              }));
            }}
          >
            <label
              className={cn(
                'cursor-pointer border rounded-2 d-flex flex-column flex-wrap align-items-center justify-content-center py-2 px-4',
                StateForm?.errors?.shipping_method ? 'border-danger' : ''
              )}
            >
              {auto_manifest && (
                <div
                  className="position-absolute h-100 w-100 border border-primary border-1 rounded-2 d-flex flex-wrap align-items-center justify-content-start"
                  style={{ zIndex: 2 }}
                >
                  <div className="ms-2 mt-n1">
                    <Fi.FiCheckCircle size={20} color="#2f83ba" />
                  </div>
                </div>
              )}

              <div
                className={cn(
                  'page-pretitle fs-8 ms-1',
                  auto_manifest ? 'text-primary' : ''
                )}
              >
                Auto Manifest
              </div>
            </label>
          </div>
        </div>
      </div>

      {/* { modal customer } */}
      <Modal
        show={showFormCustomer}
        onHide={() =>
          setState((prevState) => ({ ...prevState, showFormCustomer: false }))
        }
        backdrop="static"
        centered
        scrollable
        size="md"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Customer</Modal.Title>
        </Modal.Header>
        <CustomerForm
          selected
          onClose={(e) => {
            setState((prevState) => ({
              ...prevState,
              customer: e,
              shipper: {
                name: e?.company_name ? e?.company_name : e?.name,
                phone: e?.pic_phone,
                address: e?.address,
              },
              showFormCustomer: false,
            }));
          }}
        />
      </Modal>
    </div>
  );
};
